import httpService from "./httpService";

export default {
  search: query => httpService.get(`/typeahead?query=${encodeURIComponent(query)}`),
};
